import Vue from 'vue'
import VueRouter from 'vue-router'
import main from '@/views/main'
import terms from '@/views/Mob/components/terms'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: main
  },{
    path: '/terms',
    name: 'terms',
    component: terms
  }
]

const router = new VueRouter({
  routes
})

export default router
